 
import {required } from "@vuelidate/validators";
const OTakvim = {
    data() {
      return { 
        OTakvimData:{  
          Baslik: null,
          Baslangic: null,
          Bitis: null, 
          Kategori: null,  
          Userid: null,    
        },  
          FormDataType:{
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"},
            Baslangic:{FieldName:"Baslangic",Field:"date",FieldTitle:"Başlangıç Tarihi"},
            Bitis:{FieldName:"Bitis",Field:"date",FieldTitle:"Bitiş Tarihi"}, 
            Kategori:{FieldName:"Kategori",Field:"checkbox",FieldTitle:"Kategori",ComboDataArray:[
              {
                  Value: 'Kırmızı',
                  Id: 'bg-danger'
              },
              {
                  Value: 'Yeşil',
                  Id: 'bg-success'
              },
              {
                  Value: 'Mavi',
                  Id: 'bg-primary'
              },
              {
                  Value: 'Turkuaz',
                  Id: 'bg-info'
              },
              {
                  Value: 'Koyu Gri',
                  Id: 'bg-dark'
              },
              {
                  Value: 'Sarı',
                  Id: 'bg-warning'
              },
          ]}  
          }  
      } 
    },
    validations:{ 
      FormData: {
          Baslik: { required },  
          Baslangic: { required }, 
          Bitis: { required }, 
          Kategori: {  },  
      } 
  },
}
export default OTakvim